import { render, staticRenderFns } from "./games_player.vue?vue&type=template&id=0d158bf9&"
import script from "./games_player.vue?vue&type=script&lang=js&"
export * from "./games_player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports